import React, { useEffect, useRef, useState } from 'react'
import { useInView, AnimatePresence, motion } from 'framer-motion/dist/framer-motion'
import parse, { domToReact } from 'html-react-parser'

const options = {
    replace: ({ attribs, children }) => {
        if (!attribs) {
            return;
        }

        if (attribs.tagName === 'h1') {
            return <h1>{domToReact(children, options)}</h1>
        }

        if (attribs.tagName === 'h2') {
            return <h2>{domToReact(children, options)}</h2>
        }

        if (attribs.tagName === 'h3') {
            return <h3>{domToReact(children, options)}</h3>
        }

        if (attribs.tagName === 'p') {
            return <p>{domToReact(children, options)}</p>
        }

        if (attribs.tagName === 'ul') {
            return (
                <ul>
                    {children.map((child, i) => 
                        <li>
                            {domToReact(child.children, options)}
                        </li>
                    )}
                </ul>
            )
        }
    }
}

const SubSection = ({ data }) => {
    const ref = useRef(null)
    const isInView = useInView(ref, { once: true, amount: 0.5 });
    const [isFinished, setIsFinished] = useState(false)

    useEffect(() => {
        if (isInView) {
            setTimeout(() => {
                setIsFinished(true)
            }, 2000)
        }
    }, [isInView, setIsFinished])

    return (
        <AnimatePresence>
            <motion.div
                ref={ref}
                className={`mga-why-section__item${ isInView ? ' mga-why-section__item--visible' : ''}${isFinished ? ' mga-why-section__item--finished' : ''}`}
            >
                <motion.h3
                    style={{
                        opacity: isInView ? 1 : 0,
                        transform: isInView ? 'translateX(0)' : 'translateX(-2rem)',
                        transition: 'transform 400ms ease-out',
                    }}
                >
                    {data.title}
                </motion.h3>
                <motion.div
                    style={{
                        opacity: isInView ? 1 : 0,
                        transform: isInView ? 'translateY(0)' : 'translateY(5rem)',
                        transition: 'all 400ms ease-out',
                    }}
                >
                    {parse(data.content, options)}
                </motion.div>
            </motion.div>
        </AnimatePresence>
        
    )
}

export default SubSection